import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { requestWithAuth, debounce } from 'HELPERS/utils';
import { Icon, AutoComplete, Input } from 'antd';
import { decode } from 'html-entities';

// eslint-disable-next-line prefer-destructuring
const Option = AutoComplete.Option;

class AccountSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      sourceData: [],
      value: null,
    };
    this.fetchResults = debounce(this.fetchResults, 500);
  }

  componentDidMount() {
    if (this.props.defaultValue && this.props.defaultValue.value) {
      this.fetchSingleResult(this.props.defaultValue);
    }
  }

  componentDidUpdate(prevProps) {
    const prevDefaultValue = (prevProps.defaultValue && prevProps.defaultValue.value) || null;
    const currentDefaultValue = (this.props.defaultValue && this.props.defaultValue.value) || null;
    if ((!prevDefaultValue && currentDefaultValue) || (prevDefaultValue !== currentDefaultValue)) {
      this.fetchSingleResult(this.props.defaultValue);
    }
  }

  handleSearch = (value) => {
    if (value === '') {
      return;
    }
    if (this.state.sourceData.length && !value) {
      return this.setState({
        isLoading: false,
        sourceData: [],
      }, () => this.props.onSelectValue(null));
    }
    this.setState({ isLoading: true }, () => {
      this.fetchResults(value);
    });
  }

  handleSelect = (value) => {
    const id = parseInt(value, 0);
    const option = this.state.sourceData.find(item => item.id === id);
    this.props.onSelectValue(option);
  }

  handleChange = (value) => {
    if (value === undefined) {
      return this.setState({ value: '' }, () => {
        this.props.onSelectValue(null);
      });
    }

    this.setState({ value });
  }

  // For this autocomplete component we should avoid using redux to handle the API call logic
  // once the entire logic is limited to this scope
  fetchResults = async (value) => {
    try {
      const response = await requestWithAuth(`${process.env.REACT_APP_API_HOST}/api/v1/accounts/autocomplete?name=${value}`);
      if (response.status !== 200) {
        return this.setState({ sourceData: [], isLoading: false });
      }

      const json = await response.json();
      return this.setState({ sourceData: json.data, isLoading: false });
    } catch (error) {
      this.setState({ sourceData: [], isLoading: false });
    }
  }

  fetchSingleResult = async (defaultValue) => {
    try {
      const resource = defaultValue.type.replace('_id', '');
      this.setState({ isLoading: true });
      const response = await requestWithAuth(`${process.env.REACT_APP_API_HOST}/api/v1/${resource}s/${defaultValue.value}`);
      if (response.status !== 200) {
        return this.setState({ sourceData: [], isLoading: false });
      }

      const json = await response.json();
      return this.setState({
        value: (json.name && json.name !== ' ') ? json.name : json.email,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ sourceData: [], isLoading: false });
    }
  }

  renderOption = item => (
    <Option key={item.id} text={decode(item.name)}>
      <span className="global-search-item-count">
        {`${item.type === 'account' ? 'Site' : 'Client'} | ${decode(item.name)}`}
      </span>
    </Option>
  );

  render() {
    return (
      <AutoComplete
        allowClear
        className="autocomplete-search"
        style={{ width: '100%' }}
        dataSource={this.state.sourceData.map(item => this.renderOption(item))}
        onSelect={this.handleSelect}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        value={this.state.value}
        optionLabelProp="text"
      >
        <Input
          style={{ width: 220 }}
          placeholder="Search"
          addonBefore={<Icon type={(this.state.isLoading) ? 'loading' : 'search'} className="certain-category-icon" />}
        />
      </AutoComplete>
    );
  }
}

AccountSearch.defaultProps = {
  defaultValue: null,
};

AccountSearch.propTypes = {
  onSelectValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.object,
};

export default AccountSearch;



// WEBPACK FOOTER //
// ./src/components/DataGrid/AccountSearch.js